import React, { CSSProperties, FC, useCallback, useContext, useMemo } from 'react';

import { IOnBoardingModalSlideItem } from './models';
import { Box } from '@src/atoms/Box';
import { Text } from '@src/atoms/Text';
import { Button } from '@src/atoms/Button';

import styled from './OnBoardingSlide.module.scss';
import { Grid } from '@src/atoms/Grid';
import { classnames } from '@src/utils/classnames';
import { BreakpointsContext } from '@src/providers/Breakpoints';

interface IOnBoardingSlideProps {
  idx: number;
  item: IOnBoardingModalSlideItem;
  onClickPrevBtn(idx: number): void;
  onClickNextBtn(idx: number): void;
}

export const OnBoardingSlide: FC<IOnBoardingSlideProps> = ({ idx, item, onClickPrevBtn, onClickNextBtn }) => {
  const { isMobile } = useContext(BreakpointsContext);
  const rootClass = classnames(styled.root, isMobile && styled.mobile);
  const isNotFirstStep = idx > 0;

  const handleOnClickPrevBtn = useCallback(() => {
    onClickPrevBtn(idx);
  }, [idx, onClickPrevBtn]);

  const handleOnClickNextBtn = useCallback(() => {
    onClickNextBtn(idx);
  }, [idx, onClickNextBtn]);

  const mediaStyle = useMemo<CSSProperties>(
    () => ({
      ...item.imageStyle,
      objectFit: 'cover',
      maxHeight: 'none',
      maxWidth: 'none',
      width: '100%',
    }),
    [item.imageStyle],
  );

  return (
    <>
      <Box fullWidth className={rootClass} key={item.title + idx} column alignItems={'center'}>
        <Box fullWidth className={styled.contentContainer} column>
          <Grid alignItems={'center'} className={styled.contentWrapper}>
            {item.imageUrl && <img className={'fit-cover'} src={item.imageUrl} style={mediaStyle} alt={''} />}
            {item.videoUrl && (
              <video
                className={'fit-cover'}
                src={item.videoUrl}
                playsInline={true}
                autoPlay={true}
                style={mediaStyle}
                loop
              />
            )}
            <Box column fullWidth>
              <Text size={'h3'} id={'title'} align={isMobile ? 'left' : 'center'} className={styled.title}>
                {item.title}
              </Text>
              {item.description && (
                <Text
                  id={'description'}
                  align={isMobile ? 'left' : 'center'}
                  className={styled.descriptionText}
                  noOfLines={{ DESKTOP: 2, MOBILE: 4 }}
                >
                  {item.description}
                </Text>
              )}
              <Box
                marginTop={32}
                gap={12}
                fullWidth
                justifyContent={{ DESKTOP: 'end', MOBILE: 'spaceBetween' }}
                className={styled.buttonsWrapper}
              >
                {isNotFirstStep && (
                  <Button
                    id={'prevBtn'}
                    size={isMobile ? 'sm' : 'md'}
                    view={'secondaryDark'}
                    onClick={handleOnClickPrevBtn}
                  >
                    Назад
                  </Button>
                )}
                <Button
                  id={'nextBtn'}
                  size={isMobile ? 'sm' : 'md'}
                  view={item.nextButton.view}
                  onClick={handleOnClickNextBtn}
                >
                  {item.nextButton.content}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Box>
      </Box>
    </>
  );
};
